// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Minicart__couponForm__root","error":"cmp-Minicart__couponForm__error"};